import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { TYPE_DELETE } from '../../../constant'
import { delDeleteCompany } from '../../detailsPortfolios/store/thunk'

import {
  changeFragment,
  selectNameCompanySearch,
} from '../store/slice/sliceComponent'

export const DeleteCompanyInPortfolio = ({
  isShow,
  setShow,
  listIdsSelected,
  countItems,
  idCompanySearch,
  functionClear,
}) => {
  const dispatch = useDispatch()
  const nameCompany = useSelector(selectNameCompanySearch)

  const handleDelete = () => {
    dispatch(
      delDeleteCompany({
        portfolioIds: [...listIdsSelected],
        organizationIds: [idCompanySearch],
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeFragment())
        functionClear && functionClear()
      })
      .catch(() => {})
    setShow(false)
  }
  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title="library.main.REMOVE_FROM_PORT"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.main.REMOVE',
            event: (e) => {
              e.stopPropagation()
              handleDelete()
            },
            isI18n: true,
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
            isI18n: true,
          }}
        >
          <Element elementName="p">
            <Translate
              value="library.savePortfolio.TEXT_REMOVE_COMPANY"
              companyName={nameCompany}
              count={countItems}
              dangerousHTML
            />
          </Element>
        </PopupAction>
      )}
    </>
  )
}
